import config from "config/config";
import DEPRECATING_USERINFODIALOG from "./DEPRECATING_USERINFODIALOG";
import RELEASE_USERINFODIALOG from "./RELEASE_USERINFODIALOG";

export default function UserInfoDialog({ dialogState, setDialogState }) {
  if (config.ENABLE_CUSTOMER_PROFILE_USERINFO_UPDATE === "true")
    return (
      <RELEASE_USERINFODIALOG
        dialogState={dialogState}
        setDialogState={setDialogState}
      />
    );

  return (
    <DEPRECATING_USERINFODIALOG
      dialogState={dialogState}
      setDialogState={setDialogState}
    />
  );
}
